import React from 'react';
import Header from '../components/Header';
import { useNavigate } from 'react-router-dom';

function Construction() {

  const navigate = useNavigate()

  function enviar (){
    navigate("/")
  }
  return (
    <>
    <Header />
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 mt-[-10px]">
      <h1 className="text-3xl font-bold text-gray-800 mb-2">Página em Construção</h1>
      <p className="text-lg text-gray-600 mb-8">Em breve estará disponível. Aguarde!</p>
      <div className="w-64 h-64">
        {/* Desenho SVG de construção */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 64 64"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-yellow-500"
        >
          <path d="M32 2v60M2 32h60M16 16l32 32M48 16L16 48M32 8v8M32 48v8M8 32h8M48 32h8" />
          <circle cx="32" cy="32" r="4" />
        </svg>
      </div>
      <div className="flex justify-center mt-6 w-full max-w-[500px]">
            <button
              onClick={enviar}
              className="w-full max-w-[100px] mx-auto bg-[#f94b1b] text-white py-2 px-4 rounded-md shadow-sm hover:bg-[#d18a05]"
            >
              Voltar
            </button>
      </div>
    </div>

    </>
  );
}

export default Construction;